/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DialCode
 */
export interface DialCode {
    /**
     * 
     * @type {string}
     * @memberof DialCode
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DialCode
     */
    dialCode: string;
    /**
     * 
     * @type {string}
     * @memberof DialCode
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof DialCode
     */
    flag: string;
}

/**
 * Check if a given object implements the DialCode interface.
 */
export function instanceOfDialCode(value: object): value is DialCode {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('dialCode' in value) || value['dialCode'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('flag' in value) || value['flag'] === undefined) return false;
    return true;
}

export function DialCodeFromJSON(json: any): DialCode {
    return DialCodeFromJSONTyped(json, false);
}

export function DialCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DialCode {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'dialCode': json['dialCode'],
        'code': json['code'],
        'flag': json['flag'],
    };
}

export function DialCodeToJSON(json: any): DialCode {
    return DialCodeToJSONTyped(json, false);
}

export function DialCodeToJSONTyped(value?: DialCode | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'dialCode': value['dialCode'],
        'code': value['code'],
        'flag': value['flag'],
    };
}

